@if (languageLoaded) {
  <router-outlet></router-outlet>
}
